// Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
// RxJS
import { Observable,combineLatest, from } from 'rxjs';
import { tap,filter,map,withLatestFrom, take } from 'rxjs/operators';
// NGRX
import { select, Store } from '@ngrx/store';
// Auth reducers and selectors
import { AppState} from '../../reducers';
import { isLoggedIn,authRole } from '../_selectors/auth.selectors';
import { Logout } from '../_actions/auth.actions';
import {ENUM } from '../../enum/enum';
@Injectable()
export class CashierGuard implements CanActivate {
    constructor(private store: Store<AppState>, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> {
        return new Promise((resolve,reject) =>{
			combineLatest(
				this.store.pipe(select(isLoggedIn)),
				this.store.pipe(select(authRole)),
			  ).pipe(tap(([loggedin, authRole]) =>
			  {
				 if(!loggedin){
						 this.router.navigateByUrl('/auth/login');
				 }else if(authRole && +authRole != ENUM.roles.CASHIER){
					 if(+authRole == ENUM.roles.ADMIN){
						 this.router.navigateByUrl('/dashboard');
					 }else if(+authRole == ENUM.roles.FINANCIAL){
						this.router.navigateByUrl('/cashier-management/shifts');
					 }else if(+authRole == ENUM.roles.OPERATION){
						this.router.navigateByUrl('/queue-management/requests');
					 }else if(+authRole == ENUM.roles.AIRPORT){
						this.router.navigateByUrl('/dashboard');
					}else{
						 this.store.dispatch(new Logout());
					 }
				 }
             }
			  )).pipe(take(1)).subscribe(() => resolve(true) );
		})
    }
}
